// article.js
import axios from 'axios'


export function queryTest(_params) {
    //http://localhost:34172/api/HandleCert/GetQueryResult?TestNO=0010110054
    var url = "http://localhost:34172/api/HandleCert/GetQueryResult";
    return axios.post(url, {
        params: _params
    })
}
export function queryCert(_params) {
    //http://localhost:34172/api/HandleCert/GetQueryResult?TestNO=0010110054
    //var host2 = 'http://localhost:34172';
    var host = 'https://wxcert.hntc.cc';
    var url = host + "/api/HandleCert/GetQueryResult";
    return axios({
        url: url,
        method: "post",
        data: _params

    })
}